import React from "react";

interface SystemAlertsProps {
  title: string;
  alerts: string[];
}

const SystemAlerts: React.FC<SystemAlertsProps> = ({ title, alerts }) => {
  return (
    <div className="widget system-alerts">
      <div className="widget-header">
        <h3>{title}</h3>
      </div>
      <div className="widget-body">
        <ul className="alerts-list">
          {alerts.map((alert, index) => (
            <li key={index} className="alert-item">
              <span className="alert-icon">⚠</span>
              <span className="alert-message">{alert}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export { SystemAlerts };